export default [
  {
    path: "/warehouse",
    name: "warehouse",
    component: () => import("@/views/warehouse/Warehouse.vue"),
  },
  {
    path: "/category",
    name: "category",
    component: () => import("@/views/warehouse/Category.vue"),
  },
  {
    path: "/category/:id",
    name: "subcategory",
    component: () => import("@/views/warehouse/SubCategory.vue"),
  },
  {
    path: "/item/:id?",
    name: "item",
    component: () => import("@/views/warehouse/Item.vue"),
  },
  {
    path: "/stockin",
    name: "stockin",
    component: () => import("@/views/warehouse/Stockin.vue"),
  },
  {
    path: "/stockout/:id?",
    name: "stockout",
    component: () => import("@/views/warehouse/Stockout.vue"),
  },
  {
    path: "/create-stockin",
    name: "create-stockin",
    component: () => import("@/views/warehouse/CreateStockin.vue"),
  },
  {
    path: "/add-stockin",
    name: "add-stockin",
    component: () => import("@/views/warehouse/AddStockin.vue"),
  },
  {
    path: "/add-stockout",
    name: "add-stockout",
    component: () => import("@/views/warehouse/AddStockout.vue"),
  },
  {
    path: "/create-stockout",
    name: "create-stockout",
    component: () => import("@/views/warehouse/CreateStockout.vue"),
  },
  {
    path: "/inventory-invoice",
    name: "inventory-invoice",
    component: () => import("@/views/warehouse/Invoice.vue"),
  },
  {
    path: "/balance",
    name: "balance",
    component: () => import("@/views/warehouse/Balance.vue"),
  },
  {
    path: "/WarehouseTransfer",
    name: "warehouse-transfer",
    component: () => import("@/views/warehouse/WarehouseTransfer.vue"),
  },
  {
    path: "/department",
    name: "department",
    component: () => import("@/views/warehouse/Department.vue"),
  },
  {
    path: "/department-balance",
    name: "department-balance",
    component: () => import("@/views/warehouse/DepartmentBalance.vue"),
  },
  {
    path: "/minimum-reorder-quantity",
    name: "minimum-reorder-quantity",
    component: () => import("@/views/warehouse/MinimumReorderQuantity.vue"),
  },
];
